import React, { useEffect } from "react";
import { DetailDrawer } from "./DetailDrawer";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useSupplierModel } from "../supplierModel";
import { SyncroModel } from "./syncroModel";

export function BaseSupplier() {
    const {
        loadData,
        dataSource,
        selectedRowKeys,
        setSelectedData,
    } = useSupplierModel()

    useEffect(() => {
        loadData({ pageNum: 1 }).then()
    }, [])

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedData(selectedData)
    }, [selectedRowKeys]);

    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailDrawer />
            <SyncroModel />
        </>
    );
}

